import { useLocation } from 'react-router-dom';
import AuthShell from '../../login/components/AuthShell';
import OAuthEmailPanel from '../components/OAuthEmailPanel/OAuthEmailPanel';
import OAuthPasswordPanel from '../components/OAuthPasswordPanel/OAuthPasswordPanel';
import OAuthRequestExpired from '../components/OAuthRequestExpired/OAuthRequestExpired';
import useOAuthDiscover from '../hooks/useOAuthDiscover';
import useOAuthLogin from '../hooks/useOAuthLogin';
import useOAuthLoginFlow from '../hooks/useOAuthLoginFlow';

const OAuthLoginPage = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const oauthRequestId = searchParams.get('oauth_request_id') || '';

  const { step, showPassword, showExpired, handleBackToEmail } = useOAuthLoginFlow();
  const { handleDiscover } = useOAuthDiscover(oauthRequestId, {
    onPassword: showPassword,
    onExpired: showExpired,
  });
  const { handleLogin } = useOAuthLogin(oauthRequestId, { onExpired: showExpired });

  const renderStep = () => {
    if (step.kind === 'expired') {
      return <OAuthRequestExpired errorMessage={step.errorMessage} />;
    }

    if (step.kind === 'password') {
      return (
        <OAuthPasswordPanel
          defaultEmail={step.email}
          onSubmit={handleLogin}
          onBackToEmail={handleBackToEmail}
        />
      );
    }

    return <OAuthEmailPanel onSubmit={handleDiscover} />;
  };

  return <AuthShell>{renderStep()}</AuthShell>;
};

export default OAuthLoginPage;
